<template>
  <b-container fluid>
    <b-row class="mb-2">
      <b-col class="px-sm-3 px-0">
        <h1>Order Items</h1>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="px-sm-3 px-0">
        <b-overlay :show="loading" no-wrap fixed />
        <b-form inline class="mb-2" @submit.prevent="applyFilters">
          <b-form-input
            v-model="queryFilters.search"
            placeholder="Search by order id or item name"
            title="Search by order id or item name"
            class="mr-2 mb-2 single-input"
          />
          <custom-search-field
            v-if="hubCount > 1"
            v-model="queryFilters.hub"
            class="mr-2 mb-2 single-input"
            :placeholder="'Filter by hub'"
            :path-to-search="'facilities'"
            multiple
          />
          <custom-search-field
            v-if="brandCount > 1 || hubCount"
            v-model="queryFilters.brand"
            class="mr-2 mb-2 single-input"
            :placeholder="'Filter by brand'"
            :path-to-search="'brands'"
          />
          <custom-date-picker
            :initial-range="queryFilters.range"
            class="mr-2"
            @rangeChange="onRangeChange"
          />
          <b-button type="submit" variant="primary" class="mr-2 mb-2"
            >Filter</b-button
          >
          <b-button variant="secondary" class="mr-2 mb-2" @click="exportItems"
            >Export</b-button
          >
        </b-form>
      </b-col>
    </b-row>
    <b-row class="overflow-auto">
      <b-col class="px-sm-3 px-0">
        <b-table
          hover
          no-local-sorting
          small
          :fields="fields"
          :items="data"
          :busy="busy"
          @sort-changed="onSortingChanged"
        >
          <template #cell(network_order)="row">
            {{ row.item.network_order.number }}
          </template>
          <template #cell(brand)="row">
            {{ row.item.brand.name }}
          </template>
          <template #cell(item)="row">
            {{ row.item.item.name }}
          </template>
          <template #cell(price)="row">
            {{ (row.item.price / 100) | currency }}
          </template>
          <template #cell(order_item_attributes)="row">
            <span
              v-for="(att, index) in row.item.order_item_attributes"
              :key="att.id"
            >
              {{ att.value
              }}<template
                v-if="index !== row.item.order_item_attributes.length - 1"
                >,</template
              >
            </span>
          </template>
        </b-table>
      </b-col>
    </b-row>
    <pagination-handler v-if="data.length" :query-data="queryFilters" />
  </b-container>
</template>

<script>
import { mapGetters } from 'vuex';
import tableMixin from '../../mixins/TableMixin';
import ResourceAPI from '../../services/ResourceAPI';

export default {
  name: 'Orders',
  mixins: [tableMixin],
  data() {
    return {
      fields: [
        {
          key: 'network_order',
          sortKey: 'networkOrderNumber',
          label: 'Order ID',
          sortable: true,
        },
        {
          key: 'name',
          label: 'Item',
          sortable: true,
        },
        {
          key: 'order_item_attributes',
          label: 'Modifiers',
          thStyle: {
            width: '25%',
          },
        },
        {
          key: 'brand',
          label: 'Brand',
          sortable: true,
        },
        {
          key: 'quantity',
          label: 'Quantity',
          sortable: true,
        },
        {
          key: 'price',
          label: 'Sales',
          sortable: true,
        },
      ],
      data: [],
      loading: false,
      exportAlert: false,
    };
  },
  computed: {
    ...mapGetters('session', ['hubCount', 'brandCount']),
  },
  methods: {
    onRangeChange(range) {
      this.queryFilters.range = {
        ...range,
      };
    },
    loadResults() {
      this.setRequestData();

      // Format search params for query
      const searchParams = { ...this.queryFilters };
      searchParams.brand = searchParams.brand ? searchParams.brand.id : null;
      searchParams.facility = searchParams.hub ? searchParams.hub.id : null;
      searchParams.with = 'brand,orderItemAttributes,networkOrder';
      searchParams.startDate =
        searchParams.range && 'start' in searchParams.range
          ? this.formatDateFilter(searchParams.range.start)
          : null;
      searchParams.endDate =
        searchParams.range && 'end' in searchParams.range
          ? this.formatDateFilter(searchParams.range.end)
          : null;
      searchParams.range = null;
      searchParams.hub = null;

      return ResourceAPI.getRecords('order-items', searchParams)
        .then((data) => {
          this.setResponseData(data);
        })
        .catch((error) => alert(error));
    },

    exportItems() {
      const me = this;

      me.loading = true;

      ResourceAPI.downloadCSV(
        'reports/order-items',
        {
          startDate:
            me.queryFilters.range && 'start' in me.queryFilters.range
              ? me.formatDateFilter(me.queryFilters.range.start)
              : null,
          endDate:
            me.queryFilters.range && 'end' in me.queryFilters.range
              ? me.formatDateFilter(me.queryFilters.range.end)
              : null,
          facility: me.queryFilters.hub ? me.queryFilters.hub.id : null,
          brand: me.queryFilters.brand ? me.queryFilters.brand.id : null,
          search: me.queryFilters.search,
        },
        'order-items.csv'
      )
        .then((response) => {
          me.loading = false;
          if (response === false) {
            me.exportError = true;
            return;
          }
          me.exportError = false;
        })
        .catch((error) => alert(error));
    },
  },
};
</script>
